export const queryKeys = {
  availablePhoneNumbers: "available-phone-numbers",
  contact: "contact",
  contactPortalAccess: "contact-portal-access",
  contactTags: "contact-tags",
  contactSms: "contact-sms",
  contactSmsHandoff: "contact-sms-handoff",
  contactPhoneCalls: "contact-phone-calls",
  currentUser: "current-user",
  firm: "firm",
  firmLawWorksCharges: "firm-lawworks-charges",
  firmLeadSources: "firm-lead-sources",
  firmLeadSourceMappings: "firm-lead-source-mappings",
  firmLeadSourceMappingTargets: "firm-lead-source-mapping-targets",
  firmOffices: "firm-offices",
  firmFiles: "firm-files",
  files: "files",
  fileDuplications: "file-duplications",
  mailIntake: "mail-intake",
  firmSignatureRequests: "firm-signature-requests",
  firmPhones: "firm-phones",
  firmAppSubscriptions: "firm-app-subscriptions",
  firmPublisherApps: "firm-publisher-apps",
  firmUserGroups: "firm-user-groups",
  permissionCatalog: "permission-catalog",
  permissionGroups: "permission-groups",
  firmVirtualBusinessCards: "firm-virtual-business-cards",
  globalSearch: "global-search",
  matterDefaultFileRepositoryStructureFolders:
    "matter-default-file-repository-structure-folders",
  matterFileImages: "matter-file-images",
  matterIntelligence: "matter-intelligence",
  massTorts: "mass-torts",
  massTortSurveys: "mass-tort-surveys",
  massTortSurveyDistributions: "mass-tort-survey-distributions",
  matters: "matters",
  objectUpdates: "object-updates",
  reports: "reports",
  recentMatters: "recent-matters",
  matterSettings: "matter-settings",
  matterSettingStatics: "matter-setting-statics",
  matterLawWorksCharges: "matter-lawworks-charges",
  matterStatusCategories: "matter-status-categories",
  incidentTypeCategories: "matter-type-categories",
  matterSummary: "matter-summary",
  matterLitigationDatePlanDates: "matter-litigation-date-plan-dates",
  matterEmailPreview: "matter-email-preview",
  matterTaskPlans: "matter-task-plans",
  matterSurveys: "matter-surveys",
  matterSurvey: "matter-survey",
  matterSurveyQuestions: "matter-survey-questions",
  phaseProjects: "phase-projects",
  reusableMatterPhases: "reusable-matter-phases",
  phaseActionDefinitions: "phase-action-definitions",
  matterPhases: "matter-phases",
  matterDashboardTabs: "matter-dashboard-tabs",
  matterDashboardTables: "matter-dashboard-tables",
  matterDashboardPhaseOptions: "matter-dashboard-phase-options",
  matterDashboardActionOptions: "matter-dashboard-action-options",
  matterDashboardDataItemOptions: "matter-dashboard-data-item-options",
  matterDashboardRows: "matter-dashboard-rows",
  matterDashboardCells: "matter-dashboard-cells",
  matterDashboardUnassignedActions: "matter-dashboard-unassigned-actions",
  matterTeammates: "matter-teammates",
  matterSignatureRequests: "matter-signature-requests",
  signatureRequests: "signature-requests",
  signatureRequestPortal: "signature-request-portal",
  matterShareFolders: "matter-share-folders",
  session: "session",
  userFirm: "user-firm",
  users: "users",
  pinnedMatters: "pinned-matters",
};
